<template>
  <div class="info-time">
    <span>{{ data[fields.source] }}</span>
    <span class="delimiter">|</span>
    <span>{{ $dayjs(data[fields.time]).format('YYYY-MM-DD HH:mm') }}</span>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true
    },
    props: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    fields() {
      return {
        source: 'source',
        time: 'time',
        ...this.props
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.info-time {
  .delimiter {
    margin: 0 8px;
  }
}
</style>
